import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { CommonPage } from 'shared/layout/CommonPage'
import { SalePointCheckerFeature } from 'features/sale-point/sale-point-checker/sale-point-checker.feature'
import { WarehouseListClosedFeature } from 'features/warehouse/warehouse-list-closed.feature'
import { Preloader } from 'shared/components/preloader'
import { WarehouseViewModel } from './warehouse.view-model'

interface WarehousePageProps {}

const WarehouseClosedStockPage: React.FC<WarehousePageProps> = observer(() => {
  useEffect(() => {
    WarehouseViewModel.initClosed()
  }, [])

  return WarehouseViewModel.isLoading ? (
    <Preloader message="Loading Warehouse Data" lower />
  ) : (
    <CommonPage
      isMounted={!WarehouseViewModel.isLoading}
      title="Closed Stock"
      actions={<SalePointCheckerFeature />}
    >
      <WarehouseListClosedFeature />
    </CommonPage>
  )
})
export default WarehouseClosedStockPage
